import { useSelector } from 'react-redux';

import { cn } from '@/lib/utils';
import { getPermissions } from '@/redux/permissions/selectors';
import { Integration } from '@/shared/types/integration';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

import { ActiveFieldset } from './ActiveFieldset';
import { DeleteFieldset } from './DeleteFieldset';

interface IntegrationConfigWrapperProps {
  children: React.ReactNode;
  integration: Integration;
  selfGated?: React.ReactNode;
  className?: string;
}
export default function IntegrationConfigWrapper({
  children,
  integration,
  selfGated,
  className,
}: IntegrationConfigWrapperProps) {
  const canWrite = useSelector((state: RootState) =>
    getPermissions(state, 'integrations', actions.WRITE)
  );

  return (
    <div className="flex w-full justify-center">
      <div className={cn('flex w-xl flex-col gap-4', className)}>
        <ActiveFieldset integration={integration} />
        <fieldset disabled={!canWrite} className="contents">
          {children}
        </fieldset>
        {selfGated}
        <div className="flex justify-start">
          <DeleteFieldset integration={integration} />
        </div>
      </div>
    </div>
  );
}
